exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:1024px){.whs-sidebar{display:-webkit-box;display:-ms-flexbox;display:flex}.whs-hero{width:unset;-webkit-box-flex:4;-ms-flex:4;flex:4}}.whs-form-label{padding:4px 12px;position:absolute;font-size:11px;color:var(--color-text-5);font-weight:600;pointer-events:none}", ""]);

// exports
